import React from 'react';
import axios from 'axios';
import { Button, Modal, FormGroup, ControlLabel, FormControl } from 'react-bootstrap';

var AddListwa = React.createClass({

	getInitialState: function() {

		return {
			addObject: {
				id: '',
				numerListwy: '',
				iloscCm: '',
				ilot: '',
			}
		}
    },

	render: function() {

		return (
			<Modal show={this.props.parent.state.showAddModal}>
				<Modal.Header>
					<Modal.Title>Dodaj Listwę</Modal.Title>
				</Modal.Header>
				<Modal.Body>
						<div className="row">
							<div className="col-sm-4">
								<ControlLabel>Numer Listwy: </ControlLabel>
							</div>
							<div className="col-sm-8">
							<FormControl
								type="text"
								placeholder="Numer Listwy"
								value={this.state.addObject.numerListwy}
								onChange={this.onAddListwaNumerChange} />
							</div>
						</div>

						<div className="row">
							<div className="col-sm-4">
								<ControlLabel>Ilość cm: </ControlLabel>
							</div>
							<div className="col-sm-8">
							<FormControl
								type="text"
								placeholder="Ilość cm"
								value={this.state.addObject.iloscCm}
								onChange={this.onAddListwaIloscChange} />
							</div>
						</div>

						<div className="row">
							<div className="col-sm-4">
								<ControlLabel>Ilot: </ControlLabel>
							</div>
							<div className="col-sm-8">
							<FormControl
								type="text"
								placeholder="Ilot"
								value={this.state.addObject.ilot}
								onChange={this.onAddListwaIlotChange} />
							</div>
						</div>

				</Modal.Body>
				<Modal.Footer>
					<Button onClick={this.props.parent.closeAddModal}>Zamknij</Button>
					<Button bsStyle="primary" onClick={this.onAddBtnClicked}>Dodaj</Button>
				</Modal.Footer>
			</Modal>
		);
	},

	clearAddObject: function() {
		this.state.addObject.id = '';
		this.state.addObject.numerListwy = '';
		this.state.addObject.iloscCm = '';
		this.state.addObject.ilot = '';
	},

	onAddListwaNumerChange: function(event) {
		this.state.addObject.numerListwy = event.target.value;
		this.forceUpdate();
	},

	onAddListwaIloscChange: function(event) {
		this.state.addObject.iloscCm = event.target.value.replace(/,/g, '.');
		this.forceUpdate();
	},

	onAddListwaIlotChange: function(event) {
		this.state.addObject.ilot = event.target.value;
		this.forceUpdate();
	},


	onAddBtnClicked: function() {
		axios.post('http://217.182.200.222:8080/stanListwy/', this.state.addObject)
			.then(function (response) {
				this.props.parent.closeAddModal();
				this.props.parent.refreshTable();
			}.bind(this))
			.catch(function (error) {
				alert("Błędnie wprowadzone dane");
				console.log(error);
			});
	}
});

export default AddListwa;



// WEBPACK FOOTER //
// ./src/components/StanListwy/AddListwa.js